/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { FancyAction } from '../../common/fancy-firebase/base/FancyAction';
import { FancyActionableFirebase } from '../../common/fancy-firebase/generics/FancyActionableFirebase';
import { AttachmentList } from '../../common/fancy-firebase/lists/AttachmentList';
import { Attachment } from '../models/Attachment';

export class Attachments extends FancyActionableFirebase<Attachment, FancyAction, AttachmentList> {
	constructor(public data: AttachmentList) {
		super(data);
	}
}
